import { render, staticRenderFns } from "./xsbjgl.vue?vue&type=template&id=34891fdf&"
import script from "./xsbjgl.vue?vue&type=script&lang=js&"
export * from "./xsbjgl.vue?vue&type=script&lang=js&"
import style0 from "./xsbjgl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports